const navigationModule = {
  namespaced: true,
  state: {
    activeLink: null,
    mobileMenuOpen: false,
    overlays: [],
  },
  mutations: {
    setActiveLink(state, payload) {
      state.activeLink = payload;
    },
    setMobileMenuOpen(state, payload) {
      state.mobileMenuOpen = payload;
    },
    setOverlays(state, payload) {
      state.overlays = payload;
    },
    appendToOverlays(state, payload) {
      state.overlays.push(payload);
    },
  },
  actions: {
    optimizeOverlayData({commit}, payload) {
      const link = payload.link;
      const tabs = [];

      if (payload.data && payload.data.length) {
        payload.data.forEach((item) => {
          const links = [];
          if (item.children && item.children.length) {
            item.children.forEach((link) => {
              let linkData = {};
              linkData.uid = link.uid;
              linkData.visible = link.visible;
              if (link.url) {
                linkData.hasVisibleProducts = link.url.hasVisibleProducts;
                linkData.text = link.url.linkName;
                linkData.target = link.url.target;
                linkData.url = link.url.url;
              }
              links.push(linkData);
            });
          }
          tabs.push({
            text: item.url && item.url.linkName ? item.url.linkName : '',
            lists: [
              {
                title: 'List Title',
                children: links,
              },
            ],
          });
        });
      }

      commit('appendToOverlays', {
        parentLink: link,
        tabs: tabs,
      });
    },
    updateActiveLink({commit, state}, payload) {
      if (state.activeLink === payload) {
        commit('setActiveLink', null);
      } else {
        commit('setActiveLink', payload);
      }
    },
    unsetNav({commit}) {
      commit('setActiveLink', null);
      commit('setMobileMenuOpen', false);
    },
  },
};

export default navigationModule;
